<template>
  <div class="box-content">
     <siteSelect :showArea="showSite" :all="true" @change="siteChange"></siteSelect>
    <div class="right-box">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="故障来源">
                <j-dict-select-tag
                  dictCode="error_origin"
                  v-model="queryParam.originKey"
                  placeholder="请选择故障来源"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务类型">
                <j-dict-select-tag
                  dictCode="job_category"
                  v-model="queryParam.category"
                  placeholder="请选择任务类型"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务级别">
                <j-dict-select-tag
                  dictCode="job_level"
                  v-model="queryParam.jobLevel"
                  placeholder="请选择任务级别"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人员">
                <a-tree-select
                  style="width: 100%"
                  :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                  :treeData="userTree"
                  v-model="queryParam.userId"
                  placeholder="请选择处理人员"
                  dropdownClassName="selects"
                  show-search
                  treeNodeFilterProp="title"
                >
                  <template slot="title" slot-scope="{ title }">
                    {{ title }}
                  </template>
                </a-tree-select>
              </a-form-item>
            </a-col>

            <template v-if="toggleSearchStatus">
              <a-col :md="6" :sm="8">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
                  <a-input placeholder="请输入标题" v-model="queryParam.title" />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                  <j-dict-select-tag
                    dictCode="job_status"
                    v-model="queryParam.status"
                    placeholder="请选择状态"
                  ></j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="截止时间">
                  <a-range-picker
                    format="YYYY-MM-DD"
                    v-model="dates.endTime"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onDateEndTime"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="完成时间">
                  <a-range-picker
                    format="YYYY-MM-DD"
                    v-model="dates.completionTime"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onDateCompletionTime"
                  />
                </a-form-item>
              </a-col>
            </template>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
        <a-button @click="searchReset" icon="reload">重置</a-button>
        <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px"
          >{{ toggleSearchStatus ? '收起' : '展开' }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
        </a-button>
        <a-button :disabled="addDisabled" @click="handleAdd" type="primary" icon="plus" v-if="queryParam.scope != 4"
          >新增</a-button
        >
        <!--<a-button icon="download" @click="handleExportXls()">导出</a-button>
              <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="handleImportFile" @change="handleImportExcel">
                  <a-button  type="danger" icon="import" ghost>导入</a-button>
              </a-upload>-->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />
              删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :expandIcon="expandIcon"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">查看</a>
            <template v-if="record.userId == $store.getters.userInfo.id && (record.status == 1 || record.status == 2)">
              <a-divider type="vertical" />
              <a v-if="record.status == 1" @click="handleCheck(record, 2)">开始处理</a>
              <a v-else @click="handleCheck(record, 3)">完成处理</a>
            </template>
            <template v-if="record.status == 1 && getAuth(record.createBy)">
              <a-divider type="vertical" />
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </template>
          </span>
        </a-table>
      </div>
      <!-- table区域-end -->

      <!-- 表单区域 -->
      <jobOrder-drawer ref="modalForm" :pagePath="pagePath" @ok="modalFormOk"></jobOrder-drawer>
    </div>
  </div>
</template>

<script>
import JobOrderDrawer from './modules/JobOrderDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { queryUserTreeList } from '@/api/api'

import siteSelect from '@/components/page/siteSelect'

export default {
  name: 'JobOrderList',
  mixins: [JeecgListMixin,],
  components: {
    JobOrderDrawer,
    siteSelect
  },
  data() {
    return {
      queryParam: {
        column: 'create_time',
        order: 'desc',
      },
      showSite: true,
      pagePath: '/om/job/order',
      pageTitle: '派工单',
      autoLoadInit:false,
      siteName: '',
      addDisabled: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true,
      },
      pipeColumn: {
        dataIndex: 'siteName',
        colName: '',
        title: '管网',
        align: 'center',
        sorter: true,
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'originKey_dictText',
          colName: 'origin_key',
          title: '故障来源',
          align: 'center',
        },
        {
          dataIndex: 'category_dictText',
          colName: 'category',
          title: '任务类型',
          align: 'center',
        },
        {
          dataIndex: 'jobLevel_dictText',
          colName: 'job_level',
          title: '任务级别',
          align: 'center',
        },
        {
          dataIndex: 'title',
          colName: 'title',
          title: '标题',
          align: 'center',
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '处理人员',
          align: 'center',
        },
        {
          dataIndex: 'endTime',
          colName: 'end_time',
          title: '截止时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'completionTime',
          colName: 'completion_time',
          title: '完成时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 260,
          scopedSlots: { customRender: 'action' },
        },
      ],
      userTree: [], //人员信息
    }
  },
  created() {
    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showSite = false
      }
    }
    this.loadTreeList()
  },
  computed: {},
  methods: {
    // 1.站点 2.流域 3.管网  由于没有流域所以1.站点2.管网4.区域
    // 站点选择
    siteChange(data) {
      console.log(data)
      this.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.queryParam.scopeId = data.data.id
      this.queryParam.scope = data.scope
      // this.queryParam.operationType = data.scope
      this.siteId = data.data.id

      this.$refs.modalForm.model.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.$refs.modalForm.model.siteId = data.data.id
      this.$refs.modalForm.model.operationType = data.type

      this.columns.forEach((v, i) => {
        if (v.dataIndex.indexOf('siteName') >= 0 || v.dataIndex.indexOf('pipeName') >= 0) {
          this.columns.splice(i, 1)
        }
      })

      if (1 == data.type) {
        this.addDisabled = false
        this.queryParam.operationType = data.type
        this.judgmentValue = data.type
      } else if (2 == data.type) {
        this.addDisabled = false
        this.queryParam.operationType = data.type
        this.judgmentValue = data.type
      }

      if (4 == data.type) {
        this.addDisabled = true
        // 根据区域
        this.spliceColumn(1 == this.judgmentValue ? this.siteColumn : this.pipeColumn, 1)
      }
      this.loadData()
    },
    //加载人员信息
    loadTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          that.userTree = res.result
        }
      })
    },
    handleCheck(record, s) {
      this.$refs.modalForm.title = (s == 2 ? '开始处理：' : '完成处理：') + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showEdit = true
      this.$refs.modalForm.showCheck = true
      this.$refs.modalForm.edit(record)
    },
    handleEdit: function (record) {
      this.$refs.modalForm.title = '编辑：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.showEdit = false
      this.$refs.modalForm.edit(record)
    },
    handleAdd: function () {
      this.$refs.modalForm.title = '新增：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.showEdit = false
      let param = {
        originKey: '1',
      }
      this.$refs.modalForm.operationType = this.queryParam.operationType
      this.$refs.modalForm.siteName = this.siteName
      this.$refs.modalForm.siteId = this.siteId
      this.$refs.modalForm.edit(param)
    },
    handleDetail: function (record) {
      this.$refs.modalForm.title = this.pageTitle + '详情'
      this.$refs.modalForm.disableSubmit = true
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.showEdit = false
      this.$refs.modalForm.edit(record)
    },
    onDateEndTime: function (value, dateArray) {
      this.queryParam.endTimeStart = dateArray[0]
      this.queryParam.endTimeEnd = dateArray[1]
    },
    onDateCompletionTime: function (value, dateArray) {
      this.queryParam.completionTimeStart = dateArray[0]
      this.queryParam.completionTimeEnd = dateArray[1]
    },
    modalFormOk() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.queryParam.operationType,
        column: 'create_time',
        order: 'desc',
      }
      this.loadData()
    },
    searchReset() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.queryParam.operationType,
        column: 'create_time',
        order: 'desc',
      }
      this.dates = {}
      this.loadData(1)
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon(props) {
      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return (
              <a
                style="color: 'black',margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon type="caret-down" />
              </a>
            )
          } else {
            return (
              <a
                style="color: 'black' ,margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon style="color:red" type="caret-right" />
              </a>
            )
          }
        } else {
          return <span style="margin-right:0px"></span>
        }
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.ant-form-item-label > label {
  color: black;
}

.ant-form-item-label > label {
  color: black;
}

.box-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.right-box {
  width: calc(98% - 300px);
}
</style>
